export const Terms = process.env.LOCALE === "es-EC" ? 
[
    {
        text: 
            'Para formar parte de esta actividad, las participantes deben estar <b>registradas en NosotrasOnline.com.ec</b>, actualizar sus datos de registro y elegir la opción de registro.'
    },
    {
        text: 
            'La marca Nosotras y Productos Familia S.A. validará que los datos completados en el registro sean correctos, antes de seguir con la actividad.'
    },
    {
        text: 
            'La actividad se divide en 2 etapas. Para cada etapa habrá 5 ganadoras y se manejará de la siguiente manera:'
    },
    {
        text: 
            'Etapa 1: 1 ganadora de Iphone XR y 4 ganadoras de 6 meses de productos Nosotras.<p>Etapa 2: 1 ganadora de Iphone 13 y 4 ganadoras de 6 meses de productos Nosotras.</p>'
    },
    {
        text: 
            '<b>Los kits mencionados contendrán:</b> 3 empaques de Toallas Nosotras Invisible 30+30, 2 empaques de Toallas Buenas Noches Natural x24, 2 cajas de Protectores x200, 2 cajas de Protectores x120, 3 Jabones Íntimos Nosotras x200ml.'
    },
    {
        text: 
            'Ganará la usuaria que más CLAVES registre.'
    },
    {
        text: 
            'Cada clave ingresada cuenta como UNA clave, sin importar cuantos puntos represente.'
    },
    {
        text: 
            'Las participantes tienen que estar en el rango de edad entre los 9 y 17 años. Se les solicitará a las niñas un certificado escolar para confirmar que evidentemente están estudiando en el colegio.'
    },
    {
        text: 
            'La marca Nosotras y Productos Familia S.A. validará que los datos completados en el formulario sean correctos.'
    },
    {
        text: 
            'La usuaria debe guardar los empaques para poder participar.'
    },
    {
        text: 
        'Tendremos 2 etapas en esta actividad: si una usuaria gana en alguna de las etapas, las claves ya no tendrán validez, si pierde, seguirá concursando con las claves que tenga.'
    },
    {
        text: 
        'Habrá 2 etapas en la actividad para los premios individuales. Las claves que ingresaron las 5 ganadoras de cada etapa, se inhabilitan para la participación individual. Ellas podrán participar en las siguientes etapas pero con las nuevas claves registradas.'
    },
    {
        text: 
         'Los premios no son canjeables por ningún otro concepto o producto, ni es intercambiable por dinero.'
    },
    {
        text: 
        'En caso de que la ganadora no pueda recibir su premio, no tendrá derecho a reclamo ni a algún tipo de indemnización o compensación, ni siquiera parcialmente.'
    },
    {
        text: 
        'La marca Nosotras tiene el derecho de anular o descalificar cualquier material que considere que no cumple con las reglas del concurso. Del mismo modo procederá con el material que no tenga relación con la mecánica de la actividad, que considere no apto o que atente contra los valores de la marca.'
    },
    {
        text: 
        'Los premios de la actividad serán personales e intransferibles, y no son acumulables con otras promociones o dinámicas.'
    },
    {
        text: 
        'Con el hecho de participar en la actividad, las ganadoras aceptan y autorizan que sus nombres e imágenes aparezcan en las publicaciones y demás material de divulgación con fines promocionales que los organizadores deseen hacer durante la actividad o una vez este finalice, sin que ello implique la obligación de remunerarlas o compensarlas. Asimismo, renuncian a cualquier reclamo por derechos de imagen. Estos datos no serán recogidos para fines distintos a los expresados ni se cederán datos a terceros.'
    },
    {
        text: 
        'Las claves de las demás usuarias del ranking quedan iguales y se siguen acumulando para la segunda y la tercera etapa.'
    },
    {
        text: 
        'En la sección “MIS PUNTOS” de NosotrasOnline se aclara que las claves redimidas en esta actividad, no aplican para esta sección de redención.'
    },
    {
        text:
        'Las usuarias deben tener los empaques con los que participaron para ser ganadoras.'
    },
    {
        text:
        'Al participar en la actividad las usuarias aceptan las condiciones establecidas en el reglamento, la página web y correo electrónico.'
    },
    {
        text:
        'La actividad va de esta manera: <br>   <b>Fase 1:</b> del 3 de octubre al 6 de noviembre de 2022.<br>  <b>Fase 2:</b> del 7 de noviembre al 15 de diciembre de 2022.'
    },
    {
        text:
        'Esta actividad es válida solo para usuarias que vivan en Ecuador.'    
    },
]
: process.env.LOCALE === "es-PE" ? 
[
    {
        text: 
            'Para formar parte de esta actividad, las participantes deben estar registradas en NosotrasOnline.com.pe, actualizar sus datos de registro y elegir la opción de registro.'
    },
    {
        text: 
            'La marca Nosotras y Productos Familia S.A. validará que los datos completados en el registro sean correctos, antes de seguir con la actividad.'
    },
    {
        text: 
            'En la actividad se puede ganar individualmente o con el colegio. Individualmente pueden ganar las 2 participantes con más claves registradas: una espectacular tablet Lenovo P11 Snapdragon de 128GB y 6GB RAM + Slate Grey + Keyboard Pack y Precisión Pen 2, y con el colegio, una fiesta de promoción para los chicos de quinto de secundaria. La fiesta incluye: Local, bebidas no alcohólicas, comida, pista de baile, DJ, toldo, menaje, decoración, mozos, recuerditos, cabina de fotos instantáneas, fotografía y filmación.'
    },
    {
        text: 
            'Solo habrá un colegio ganador en todo el país.'
    },
    {
        text: 
            'Ganará la usuaria y/o colegio que más CLAVES registre.'
    },
    {
        text: 
            'Cada clave ingresada cuenta como UNA clave, sin importar cuantos puntos represente.'
    },
    {
        text: 
            'Las participantes tienen que estar en el rango de edad entre los 9 y 17 años (menor a 17). Se les solicitará a las niñas un certificado escolar para confirmar que evidentemente están estudiando en el colegio.'
    },
    {
        text: 
            'La marca Nosotras y Productos Familia S.A. validará que los datos completados en el formulario sean correctos.'
    },
    {
        text: 
            'La usuaria debe guardar los empaques para poder participar.'
    },
    {
        text: 
            'Las niñas podrán participar por los premios individuales o por el premio mayor.'
    },
    {
        text: 
        'Los premios no son canjeables por ningún otro concepto o producto, ni es intercambiable por dinero.'
    },
    {
        text: 
        'En caso de que la ganadora no pueda recibir su premio, no tendrá derecho a reclamo ni a algún tipo de indemnización o compensación, ni siquiera parcialmente.'
    },
    {
        text: 
         'La marca Nosotras tiene el derecho de anular o descalificar cualquier material que considere que no cumple con las reglas del concurso. Del mismo modo procederá con el material que no tenga relación con la mecánica de la actividad, que considere no apto o que atente contra los valores de la marca.'
    },
    {
        text: 
        'Los premios de la actividad serán personales e intransferibles, y no son acumulables con otras promociones o dinámicas.'
    },
    {
        text: 
        'Con el hecho de participar en la actividad, las ganadoras aceptan y autorizan que sus nombres e imágenes aparezcan en las publicaciones y demás material de divulgación con fines promocionales que los organizadores deseen hacer durante la actividad o una vez este finalice, sin que ello implique la obligación de remunerarlas o compensarlas. Asimismo, renuncian a cualquier reclamo por derechos de imagen. Estos datos no serán recogidos para fines distintos a los expresados ni se cederán datos a terceros.'
    },
    {
        text: 
        'Si una usuaria ingresó su colegio, TODAS las claves que registre le contarán para su puntaje individual y para el puntaje de su colegio.'
    },
    {
        text: 
        'Si una usuaria registro su colegio posterior  a su registro individual, solo le sumarán a su colegio las claves que registre a partir de ese momento y las que haya registrado anteriormente solo le cuentan en su ranking individual.'
    },
    {
        text: 
        'Las usuarias no podrán cambiar el colegio registrado. Si requiere o necesita cambiarlo por alguna razón de fuerza mayor o porque está duplicado, debe contactarse a través de los canales de atención y solicitarlo como un soporte.'
    },
    {
        text: 
        'En la sección “MIS PUNTOS” de NosotrasOnline se aclara que las claves redimidas en esta actividad, no aplican para esta sección de redención.'
    },
    {
        text:
        'En los campos de “AGREGAR COLEGIO” solo registra mayúsculas. Si una usuaria escribe en minúscula, automáticamente se traduce a mayúsculas. Además no admite caracteres especiales, no tildes, guiones, puntos, comas, etc.'
    },
    {
        text:
        'Si una usuaria registra un nuevo colegio, este debe prescribir la bdd y aparecer en próximos registros.'
    },
    {
        text:
        'Las usuarias deben tener los empaques con los que participaron para ser ganadoras.'    
    },
    {
        text:
        'Al final del concurso, la concursante debe tener una carta que certifique que estudia en el colegio registrado y copia de su documento.'    
    },
    {
        text:
        'Al participar en la actividad las usuarias aceptan las condiciones establecidas en el reglamento, la página web y correo electrónico.'    
    },
    {
        text:
        'Inmediatamente se conozca el nombre del colegio ganador se deberá tener una reunión con los encargados de la institución para coordinar fecha del evento y tipo de evento (Bazar, Prom, Día de la familia, etc) para poder definir el material que el colegio requiere para llevarlo a cabo. La fiesta debe realizarse en las instalaciones del colegio y debe realizarse durante el segundo semestre del 2022.'    
    },
    {
        text:
        'La actividad va de octubre a diciembre(validar fechas exactas).'    
    },
    {
        text:
        'Esta actividad es válida solo para usuarias que vivan en Perú.'    
    },
]
:
[
    {
        text:
            `Para formar parte de esta actividad, las participantes deben estar 
            <b>registradas en NosotrasOnline.com.co</b>, actualizar sus datos de
            registro y elegir la opción de registro.`
            
    },
    {
        text: 
        `La marca Nosotras y Productos Familia S.A. validará que los datos
        completados en el registro sean correctos, antes de seguir con la
        actividad.`
      
    },
    {
        text: 
        `La actividad se divide en 4 etapas. Para cada etapa habrá 5
        ganadoras y se manejará de la siguiente manera:
        <p>Etapa 1: 1 Iphone 13 y 4 kits (5 ganadoras)</p>
        <p>Etapa 2: 1 Iphone 13 y 4 kits (5 ganadoras)</p>
        <p>Etapa 3: 1 Iphone 13 y 4 kits (5 ganadoras)</p>
        <p>Etapa 4: colegio ganador</p>`
      
    },
    {
        text: 
        `<b>Los kits mencionados contendrán:</b> Nosotras Pañitos Íntimos
        Sensitive x 16, Nosotras Pañitos Íntimos Herbal x 16, Nosotras
        Pañitos Húmedos Frescura Extrema x 16, Nosotras Pañitos Húmedos Agua
        de Rosas x16, Nosotras Jabón Íntimo Agua de Rosas 200 ml, Nosotras
        Jabón Íntimo Fórmula Herbal x 200ml, Nosotras, Jabón Íntimo Frescura
        Extremo x 200 ml, Nosotras Jabón Íntimo Lavanda x 200ml, Nosotras
        Jabón Íntimo Sensitive x 200 ml, Nosotras Tampón Aplicador Orgánicos
        Regular x 8, Nosotras Tampón Aplicador Regular x 8, Nosotras Tampón
        Sensiti-V aplicador regular x 8, Nosotras, Buenas Noches Máxima
        Protección Talla M X 3, Nosotras Natural Buenas Noches x 10,
        Nosotras Invisible Multiestilo x 10, Nosotras Invisible Orgánicos x
        10, Nosotras Diarios Largos Con Alas Multiestilo x 72, Nosotras
        Diarios Multiestilo Sensitive x 100, Nosotras Diarios Normal x 150,
        Nosotras Extra Protección Tela x 6, Nosotras Invisible Rapigel X 10,
        Nosotras Natural Invisible x 8, Nosotras Panty Intimawear Bikini
        Vinotinto Talla M x 1.`
      
    },
    {
        text: 
        `El premio final incluiría: Sonido, 1 Tarima, Hasta 10 Carpas, Hasta
        400 sillas, Decoración, 1 Pantalla Led, 1 DJ, 1 Animador, Rifas de
        la marca, Obsequios de la marca, 1 Actividad lúdica tipo feria (si
        el evento lo requiere).`
      
    },
    {
        text: 
        `<b>Solo habrá un colegio ganador en todo el país.</b>`
      
    },
    {
        text: 
        `<b>Ganará la usuaria y/o colegio que más CLAVES registre.</b>`
      
    },
    {
        text: 
        `Cada clave ingresada cuenta como UNA clave, sin importar cuantos
        puntos represente.`
      
    },
    {
        text: 
        `Las participantes tienen que estar en el rango de edad entre los 9 y
        19 años (menor a 18). Se les solicitará a las niñas un certificado
        escolar para confirmar que evidentemente están estudiando en el
        colegio.`
      
    },
    {
        text: 
        `La marca Nosotras y Productos Familia S.A. validará que los datos
        completados en el formulario sean correctos.`
      
    },
    {
        text: 
        `La usuaria debe guardar los empaques para poder participar.`
    },
    {
        text: 
        
        `Las niñas podrán participar por los premios individuales o por el
        premio mayor.`
      
    },
    {
        text: 
        
        `Tendremos 4 etapas en esta actividad: si una usuaria gana en alguna
        de las etapas, las claves ya no tendrán validez, si pierde, seguirá
        concursando con las claves que tenga.`
      
    },
    {
        text: 
        
        `Habrá 4 etapas en la actividad para los premios individuales. Las
        claves que ingresaron las 5 ganadoras de cada etapa, se inhabilitan
        para la participación individual. Ellas podrán participar en las
        siguientes etapas pero con las nuevas claves registradas.`
      
    },
    {
        text: 
        
        `Los premios no son canjeables por ningún otro concepto o producto,
        ni es intercambiable por dinero.`
      
    },
    {
        text: 
        
        `En caso de que la ganadora no pueda recibir su premio, no tendrá
        derecho a reclamo ni a algún tipo de indemnización o compensación,
        ni siquiera parcialmente.`
      
    },
    {
        text: 
        
        `La marca Nosotras tiene el derecho de anular o descalificar
        cualquier material que considere que no cumple con las reglas del
        concurso. Del mismo modo procederá con el material que no tenga
        relación con la mecánica de la actividad, que considere no apto o
        que atente contra los valores de la marca.`
      
    },
    {
        text: 
        
        `Los premios de la actividad serán personales e intransferibles, y no
        son acumulables con otras promociones o dinámicas.`
      
    },
    {
        text: 
        
        `Con el hecho de participar en la actividad, las ganadoras aceptan y
        autorizan que sus nombres e imágenes aparezcan en las publicaciones
        y demás material de divulgación con fines promocionales que los
        organizadores deseen hacer durante la actividad o una vez este
        finalice, sin que ello implique la obligación de remunerarlas o
        compensarlas. Asimismo, renuncian a cualquier reclamo por derechos
        de imagen. Estos datos no serán recogidos para fines distintos a los
        expresados ni se cederán datos a terceros.`
      
    },
    {
        text:
        
        `Las claves de las demás usuarias del ranking quedan iguales y se
        siguen acumulando para la segunda y la tercera etapa.`
      
    },
    {
        text:
        
        `Si una usuaria ingresó su colegio, TODAS las claves que registre le
        contarán para su puntaje individual y para el puntaje de su colegio.`
      
    },
    {
        text:
                
                `Si una usuaria registro su colegio posterior a su registro
                individual, solo le sumarán a su colegio las claves que registre a
                partir de ese momento y las que haya registrado anteriormente solo
                le cuentan en su ranking individual.`
                
    },
    {
        text:
        
            `El ranking de colegios no se afecta por las etapas parciales.`
    },
    {
        text:
        
        `Las usuarias no podrán cambiar el colegio registrado. Si requiere o
        necesita cambiarlo por alguna razón de fuerza mayor o porque está
        duplicado, debe contactarse a través de los canales de atención y
        solicitarlo como un soporte.`
      
    },
    {
        text:
        
        `En la sección “MIS PUNTOS” de NosotrasOnline se aclara que las
        claves redimidas en esta actividad, no aplican para esta sección de
        redención.`
      
    },
    {
        text:
        
        `En los campos de “AGREGAR COLEGIO” solo registra mayúsculas. Si una
        usuaria escribe en minúscula, automáticamente se traduce a
        mayúsculas. Además no admite caracteres especiales, no tildes,
        guiones, puntos, comas, etc.`
      
    },
    {
        text:
        
        `Si una usuaria registra un nuevo colegio, este debe prescribir la
        bdd y aparecer en próximos registros.`
      
    },
    {
        text:
        
        `Las usuarias deben tener los empaques con los que participaron para
        ser ganadoras.`
      
    },
    {
        text:
        
        `Al final del concurso, la concursante debe tener una carta que
        certifique que estudia en el colegio registrado y copia de su
        documento.`
      
    },
    {
        text:
        
        `Al participar en la actividad las usuarias aceptan las condiciones
        establecidas en el reglamento, la página web y correo electrónico.`
      
    },
    {
        text:
        
        `<b>
          Inmediatamente se conozca el nombre del colegio ganador se deberá
          tener una reunión con los encargados de la institución para
          coordinar fecha del evento y tipo de evento
        </b>
        (Bazar, Prom, Día de la familia, etc) para poder definir el material
        que el colegio requiere para llevarlo a cabo. La fiesta debe
        realizarse en las instalaciones del colegio y debe realizarse
        durante el segundo semestre del 2022.`
      
    },
    {
        text:
        
        `La actividad va del 15 de marzo al 31 de agosto de 2022.
        <b>Primera etapa:</b> 15 marzo al 15 de mayo - Ganadoras 30 mayo.
        <b>Segunda etapa:</b> 16 de mayo al 15 de julio - Ganadoras 1 de
        agosto. <b>Tercera etapa:</b> 16 de julio al 31 de agosto -
        Ganadoras 15 de septiembre <b>Cuarta etapa:</b> la fecha de
        finalización es la misma de la etapa 3. (Última etapa y Colegio
        ganador final).`
      
    },
    {
        text:
        
        `Esta actividad es válida solo para usuarias que vivan en Colombia.`
      
    },
]
